export var ARTICLE_BOX = 'article-box';
export var ARTICLE_BOX_MOBILE_WIDTH = '100%';
export var ARTICLE_BOX_DESKTOP_WIDTH = 290;
//# sourceMappingURL=constants.js.map